import { createElement } from "react";

import type {
  PlayRendererDefinition,
  PlayRendererHostProps,
  PlayRendererRegistration
} from "./contracts";
import { RegisteredActivity } from "./RegisteredActivity";

export function definePlayRenderer<
  TPayload,
  TState,
  TAction,
  TRenderModel
>(
  definition: PlayRendererDefinition<
    TPayload,
    TState,
    TAction,
    TRenderModel
  >
): PlayRendererRegistration {
  function RegisteredRenderer(props: PlayRendererHostProps) {
    const { sessionKey, ...activityProps } = props;
    const ActivityComponent = RegisteredActivity<
      TPayload,
      TState,
      TAction,
      TRenderModel
    >;

    return createElement(ActivityComponent, {
      ...activityProps,
      definition,
      key: sessionKey
    });
  }

  return {
    activityType: definition.adapter.activityType,
    feedbackAudioPolicy: definition.feedbackAudioPolicy ?? "generic",
    Renderer: RegisteredRenderer
  };
}
